<template>
  <div id="app" role="main">
    <section class="hidden">
      <h1>Norbert Nagy</h1>
      <h2>Front End Developer - Personal Website</h2>
    </section>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view :bio="bio" />
  </div>
</template>

<script>
import db from '@/firebase/init';

export default {
  data() {
    return {
      bio: {},
    };
  },
  created() {
    db.collection('bio').get().then((response) => {
      response.docs.forEach((doc) => {
        this.$set(this.bio, doc.id, doc.data())
      });
    });
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.hidden {
  display: none;
}
</style>
